(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.coinerBundleMoneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getEditIdFromUrl() {
    try {
      return new URLSearchParams(window.location.search).get('edit') || '';
    } catch (e) {
      return '';
    }
  }

  function discountedUnitPrice(unitPriceCents, tier) {
    if (!tier) return unitPriceCents;
    if (tier.discount_type === 'amount') {
      return Math.max(0, unitPriceCents - (tier.amount_off || 0));
    }
    return Math.round(unitPriceCents * (1 - (tier.percent || 0) / 100));
  }

  function tierUnlockPrice(tier, unitPrice) {
    if (!tier) return unitPrice;
    if (tier.discount_type === 'amount') {
      return Math.max(0, unitPrice - (tier.amount_off || 0));
    }
    return Math.round(unitPrice * (1 - (tier.percent || 0) / 100));
  }

  function tierNudgeLabel(tier, unitPrice) {
    return formatMoney(tierUnlockPrice(tier, unitPrice)) + '/each';
  }

  function initSection(root) {
    if (!root || root.dataset.coinerBundleInit === '1') return;
    root.dataset.coinerBundleInit = '1';

    const bundleHandle = root.dataset.bundleHandle || '';
    const minCheckout = parseInt(root.dataset.minCheckout || '0', 10) || 0;
    const basePrice = parseInt(root.dataset.basePrice || '0', 10) || 0;
    const anchorVariantId = parseInt(root.dataset.anchorVariantId || '0', 10) || 0;
    const addLabel = root.dataset.addLabel || 'Add bundle to cart';
    const updateLabel = root.dataset.updateLabel || 'Update bundle';

    let tiers = [];
    try {
      tiers = JSON.parse(root.dataset.tiers || '[]');
    } catch (e) {
      tiers = [];
    }
    tiers = tiers.map(function (t) {
      return {
        min_qty: Number(t.min_qty),
        discount_type: t.discount_type || 'percent',
        percent: Number(t.percent || 0),
        amount_off: Number(t.amount_off || 0),
        show_label: t.show_label !== false,
      };
    });
    tiers.sort((a, b) => a.min_qty - b.min_qty);

    const selections = new Map();
    let editBundleId = getEditIdFromUrl();
    let editLineKey = null;
    let bundleIdForCart = editBundleId || uuid();

    let ladderSteps = root.querySelectorAll('[data-coiner-ladder-step]');
    const editBanner = root.querySelector('[data-coiner-edit-banner]');

    layoutMilestones();

    const addBtn = root.querySelector('[data-coiner-add]');
    const mobileAddBtns = root.querySelectorAll('[data-coiner-mobile-add], [data-coiner-mobile-add-dock]');
    const mobileRoot = root.querySelector('.coiner-bundle-mobile');
    const mobileToggles = root.querySelectorAll('[data-coiner-mobile-toggle]');
    const mobileBackdrop = root.querySelector('[data-coiner-mobile-backdrop]');
    const mobileClose = root.querySelector('[data-coiner-mobile-close]');
    const mobileHide = root.querySelector('[data-coiner-mobile-hide]');
    const heroVideo = root.querySelector('.coiner-bundle-hero__video');
    const playOverlay = root.querySelector('.coiner-bundle-hero__play');

    function setMobileSheetOpen(open) {
      if (!mobileRoot) return;
      mobileRoot.classList.toggle('is-expanded', open);
      mobileToggles.forEach(function (btn) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      root.querySelectorAll('[data-coiner-chevron]').forEach(function (el) {
        el.textContent = open ? '▼' : '▲';
      });
      root.querySelectorAll('[data-coiner-chevron-sheet]').forEach(function (el) {
        el.textContent = '▼';
      });
      if (mobileBackdrop) mobileBackdrop.hidden = !open;
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    function playHeroVideo() {
      if (!heroVideo) return;
      heroVideo.controls = true;
      heroVideo.muted = false;
      const playPromise = heroVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          heroVideo.muted = true;
          heroVideo.play();
        });
      }
      if (playOverlay) playOverlay.classList.add('is-hidden');
    }

    root.querySelectorAll('[data-coiner-video-play]').forEach(function (btn) {
      btn.addEventListener('click', playHeroVideo);
    });

    function activeTier(totalQty) {
      let best = null;
      for (const t of tiers) {
        if (totalQty >= t.min_qty) best = t;
      }
      return best;
    }

    function nextTier(totalQty) {
      for (const t of tiers) {
        if (totalQty < t.min_qty) return t;
      }
      return null;
    }

    function cardFor(id) {
      return root.querySelector('.coiner-bundle-card[data-variant-id="' + id + '"]');
    }

    function avgUnitPrice() {
      if (selections.size === 0) return basePrice;
      let sum = 0;
      let qty = 0;
      selections.forEach(function (q, id) {
        const card = cardFor(id);
        if (!card) return;
        sum += parseInt(card.dataset.price || '0', 10) * q;
        qty += q;
      });
      return qty > 0 ? Math.round(sum / qty) : basePrice;
    }

    function priceForTierStep(step, unitPrice) {
      const type = step.dataset.discountType || 'percent';
      if (type === 'amount') {
        const amountOff = parseInt(step.dataset.amountOff || '0', 10);
        return Math.max(0, unitPrice - amountOff);
      }
      const pct = parseInt(step.dataset.percent || '0', 10);
      return Math.round(unitPrice * (1 - pct / 100));
    }

    function maxTierQty() {
      return tiers.length ? tiers[tiers.length - 1].min_qty : 1;
    }

    function milestoneLeftPct(minQty) {
      const maxQty = maxTierQty();
      return maxQty > 0 ? (minQty / maxQty) * 100 : 0;
    }

    function layoutMilestones() {
      const maxQty = maxTierQty();
      root.querySelectorAll('[data-coiner-ladder]').forEach(function (ladder) {
        const steps = ladder.querySelectorAll('[data-coiner-ladder-step]');
        steps.forEach(function (step, index) {
          const minQty = parseInt(step.dataset.minQty || '0', 10);
          step.style.left = milestoneLeftPct(minQty) + '%';
        });
      });
      root.querySelectorAll('[data-coiner-tier-track], [data-coiner-tier-track-mobile]').forEach(function (track) {
        track.style.setProperty('--cb-milestone-max', String(maxQty));
      });
    }

    function updateLadderPrices(unitPrice) {
      ladderSteps.forEach(function (step) {
        const discounted = priceForTierStep(step, unitPrice);
        const nowEl = step.querySelector('[data-ladder-now]');
        if (nowEl) nowEl.textContent = formatMoney(discounted);
      });
    }

    function updateTierProgress(qty) {
      const maxQty = maxTierQty();
      const pct = maxQty > 0 ? Math.min(100, (qty / maxQty) * 100) : 0;
      root.querySelectorAll('[data-coiner-tier-progress]').forEach(function (fill) {
        fill.style.width = pct + '%';
      });
      root.querySelectorAll('[data-coiner-progress-thumb]').forEach(function (thumb) {
        const track = thumb.closest('.coiner-bundle-milestones__track');
        if (qty <= 0) {
          thumb.hidden = true;
        } else {
          thumb.hidden = false;
          thumb.style.left = 'calc(30px + (100% - 60px) * ' + pct + ' / 100)';
        }
        if (track) track.style.setProperty('--cb-progress', String(pct));
      });
    }

    function renderCardPrice(priceEl, base, compare, tier) {
      const discounted = discountedUnitPrice(base, tier);
      const hasTierDiscount = tier && discounted < base;
      const hasCompare = compare > base && !hasTierDiscount;

      if (hasTierDiscount) {
        priceEl.innerHTML =
          '<span class="coiner-bundle-price-inline">' +
          '<span class="coiner-bundle-price-inline__was">' +
          formatMoney(base) +
          '</span>' +
          '<span class="coiner-bundle-price-inline__now">' +
          formatMoney(discounted) +
          '</span>' +
          '</span>';
      } else if (hasCompare) {
        priceEl.innerHTML =
          '<span class="coiner-bundle-price-inline">' +
          '<span class="coiner-bundle-price-inline__was">' +
          formatMoney(compare) +
          '</span>' +
          '<span class="coiner-bundle-price-inline__now">' +
          formatMoney(base) +
          '</span>' +
          '</span>';
      } else {
        priceEl.innerHTML =
          '<span class="coiner-bundle-price-inline">' +
          '<span class="coiner-bundle-price-inline__now coiner-bundle-price-inline__now--solo">' +
          formatMoney(base) +
          '</span>' +
          '</span>';
      }
    }

    function updateCardPrices(tier) {
      root.querySelectorAll('.coiner-bundle-card').forEach(function (card) {
        const priceEl = card.querySelector('[data-coiner-card-price]');
        if (!priceEl) return;
        const base = parseInt(card.dataset.price || '0', 10);
        const compare = parseInt(card.dataset.comparePrice || '0', 10);
        renderCardPrice(priceEl, base, compare, tier);
      });
    }

    function setQty(variantId, qty) {
      const card = cardFor(variantId);
      const max = card ? parseInt(card.dataset.maxQty || '999', 10) : 999;
      qty = Math.max(0, Math.min(max, qty));
      if (qty === 0) selections.delete(variantId);
      else selections.set(variantId, qty);

      if (card) {
        card.classList.toggle('is-active', qty > 0);
        const display = card.querySelector('[data-qty-display]');
        if (display) display.textContent = String(qty);
      }
      updateUI();
    }

    function changeQty(variantId, delta) {
      setQty(variantId, (selections.get(variantId) || 0) + delta);
    }

    function totals() {
      let qty = 0;
      let subtotal = 0;
      selections.forEach(function (q, id) {
        const card = cardFor(id);
        if (!card) return;
        const price = parseInt(card.dataset.price || '0', 10);
        qty += q;
        subtotal += price * q;
      });

      const tier = activeTier(qty);
      let discount = 0;
      let total = subtotal;

      if (tier) {
        if (tier.discount_type === 'amount') {
          discount = (tier.amount_off || 0) * qty;
        } else {
          discount = Math.round(subtotal * ((tier.percent || 0) / 100));
        }
        total = subtotal - discount;
      }

      const perItem = qty > 0 ? Math.round(total / qty) : avgUnitPrice();
      const pct =
        tier && tier.discount_type !== 'amount' && subtotal > 0
          ? tier.percent || 0
          : tier && tier.discount_type === 'amount' && subtotal > 0
            ? Math.round((discount / subtotal) * 100)
            : 0;

      return { qty, subtotal, discount, total, tier, pct, perItem };
    }

    function checkoutLabel() {
      return editLineKey ? updateLabel : addLabel;
    }

    function syncCheckoutButtons() {
      const label = checkoutLabel();
      [addBtn].concat(Array.from(mobileAddBtns)).forEach(function (btn) {
        if (btn && !btn.disabled && !btn.dataset.loading) btn.textContent = label;
      });
    }

    function renderMobileList(t) {
      const mobileList = root.querySelector('[data-coiner-selected-list-mobile]');
      if (!mobileList) return;
      if (t.qty === 0) {
        mobileList.innerHTML =
          '<li class="coiner-bundle-mobile__empty">Your bundle is empty — tap items above to add</li>';
        return;
      }
      let html = '';
      selections.forEach(function (q, id) {
        const card = cardFor(id);
        if (!card) return;
        const price = parseInt(card.dataset.price || '0', 10);
        html +=
          '<li class="coiner-bundle-mobile-item">' +
          '<img src="' +
          (card.dataset.image || '') +
          '" alt="" width="52" height="52">' +
          '<div class="coiner-bundle-mobile-item__info">' +
          '<strong>' +
          (card.dataset.title || '') +
          '</strong>' +
          '<span>' +
          formatMoney(price) +
          ' each</span>' +
          '</div>' +
          '<div class="coiner-bundle-mobile-item__qty">' +
          '<button type="button" data-mobile-dec="' +
          id +
          '" aria-label="Decrease">−</button>' +
          '<span>' +
          q +
          '</span>' +
          '<button type="button" data-mobile-inc="' +
          id +
          '" aria-label="Increase">+</button>' +
          '</div></li>';
      });
      mobileList.innerHTML = html;
      mobileList.querySelectorAll('[data-mobile-dec]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          changeQty(btn.getAttribute('data-mobile-dec'), -1);
        });
      });
      mobileList.querySelectorAll('[data-mobile-inc]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          changeQty(btn.getAttribute('data-mobile-inc'), 1);
        });
      });
    }

    function buildProperties(t) {
      const itemList = [];
      const properties = {
        _coiner_bundle: bundleHandle,
        _coiner_bundle_id: bundleIdForCart,
        _coiner_compare_cents: String(t.subtotal),
        _coiner_final_cents: String(t.total),
        _coiner_tier_pct: String(t.pct),
      };

      if (t.tier) {
        properties._coiner_tier_type = t.tier.discount_type || 'percent';
        if (t.tier.discount_type === 'amount') {
          properties._coiner_tier_amount = String(t.tier.amount_off || 0);
        }
      }

      selections.forEach(function (q, id) {
        const card = cardFor(id);
        if (!card) return;
        const title = card.dataset.title || 'Item';
        itemList.push({ id: Number(id), qty: q, title: title });
        properties['x' + q + ' ' + title] = '';
      });

      properties._coiner_items = JSON.stringify(itemList);
      return properties;
    }

    function updateUI() {
      const t = totals();
      const nt = nextTier(t.qty);
      const unitForLadder = avgUnitPrice();

      root.querySelectorAll('[data-coiner-count]').forEach(function (el) {
        el.textContent = String(t.qty);
      });
      root.querySelectorAll('[data-coiner-subtotal]').forEach(function (el) {
        el.textContent = formatMoney(t.subtotal);
      });
      root.querySelectorAll('[data-coiner-discount]').forEach(function (el) {
        el.textContent = t.discount > 0 ? '−' + formatMoney(t.discount) : formatMoney(0);
        el.closest('[data-coiner-discount-row]')?.classList.toggle('is-hidden', t.discount <= 0);
      });
      root.querySelectorAll('[data-coiner-total]').forEach(function (el) {
        el.textContent = formatMoney(t.total);
      });

      const avgBeforeDiscount = t.qty > 0 ? Math.round(t.subtotal / t.qty) : basePrice;
      root.querySelectorAll('[data-coiner-per-mini]').forEach(function (el) {
        const next = t.qty > 0 ? formatMoney(t.perItem) : formatMoney(basePrice);
        if (el.textContent !== next) {
          el.classList.add('is-tick');
          window.setTimeout(function () {
            el.classList.remove('is-tick');
          }, 420);
        }
        el.textContent = next;
      });

      root.querySelectorAll('[data-coiner-compare-per]').forEach(function (el) {
        if (t.discount > 0 && t.qty > 0) {
          el.textContent = formatMoney(avgBeforeDiscount);
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });

      root.querySelectorAll('[data-coiner-save-amt]').forEach(function (el) {
        el.textContent = t.discount > 0 ? 'You save ' + formatMoney(t.discount) + ' on this bundle' : '';
        el.classList.toggle('is-visible', t.discount > 0);
      });

      root.querySelectorAll('[data-coiner-nudge-wrap]').forEach(function (wrap) {
        wrap.classList.toggle('is-unlocked', !!t.tier && t.discount > 0);
      });

      root.querySelectorAll('.coiner-bundle-rail [data-coiner-nudge]').forEach(function (el) {
        if (minCheckout > 0 && t.qty > 0 && t.qty < minCheckout) {
          el.textContent = 'Add ' + (minCheckout - t.qty) + ' more to checkout (' + minCheckout + ' minimum)';
        } else if (nt) {
          el.textContent =
            'Add ' + (nt.min_qty - t.qty) + ' more to unlock ' + tierNudgeLabel(nt, unitForLadder);
        } else if (t.tier) {
          el.textContent = 'Best price unlocked — ' + tierNudgeLabel(t.tier, unitForLadder);
        } else {
          el.textContent = 'Add items to unlock bundle savings';
        }
      });

      root.querySelectorAll('.coiner-bundle-mobile [data-coiner-nudge]').forEach(function (el) {
        if (minCheckout > 0 && t.qty > 0 && t.qty < minCheckout) {
          el.textContent = 'Add ' + (minCheckout - t.qty) + ' more to checkout (' + minCheckout + ' minimum)';
        } else if (nt) {
          el.textContent =
            'Add ' +
            (nt.min_qty - t.qty) +
            ' more, pay ' +
            tierNudgeLabel(nt, unitForLadder).replace('/each', ' each');
        } else if (t.tier) {
          el.textContent = 'Best price unlocked — ' + tierNudgeLabel(t.tier, unitForLadder).replace('/each', ' each');
        } else {
          el.textContent = 'Add items to unlock bundle savings';
        }
      });

      root.querySelectorAll('[data-coiner-mobile-discount-tag]').forEach(function (el) {
        if (t.tier && t.discount > 0) {
          if (t.tier.discount_type === 'amount') {
            el.textContent = ' · ' + formatMoney(t.tier.amount_off || 0) + ' off';
          } else {
            el.textContent = ' · ' + (t.pct || 0) + '% off';
          }
          el.classList.add('is-visible');
        } else {
          el.textContent = '';
          el.classList.remove('is-visible');
        }
      });

      root.querySelectorAll('[data-coiner-mobile-save-tag]').forEach(function (el) {
        el.textContent = t.discount > 0 ? 'save ' + formatMoney(t.discount) : '';
        el.classList.toggle('is-visible', t.discount > 0);
      });

      ladderSteps.forEach(function (step) {
        const th = parseInt(step.dataset.minQty || '0', 10);
        step.classList.toggle('is-reached', t.qty >= th);
        step.classList.toggle('is-active', false);
      });

      updateLadderPrices(unitForLadder);
      updateCardPrices(t.tier);
      updateTierProgress(t.qty);

      const list = root.querySelector('[data-coiner-selected-list]');
      if (list) {
        if (t.qty === 0) {
          list.innerHTML = '<li style="color:var(--cb-muted);text-align:center;padding:8px;">Your bundle is empty</li>';
        } else {
          let html = '';
          selections.forEach(function (q, id) {
            const card = cardFor(id);
            if (!card) return;
            html +=
              '<li class="coiner-bundle-selected-item">' +
              '<img src="' +
              (card.dataset.image || '') +
              '" alt="" width="44" height="44">' +
              '<div><strong>' +
              (card.dataset.title || '') +
              '</strong><br><span>Qty ' +
              q +
              '</span></div>' +
              '<button type="button" data-remove="' +
              id +
              '">×</button></li>';
          });
          list.innerHTML = html;
          list.querySelectorAll('[data-remove]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              setQty(btn.getAttribute('data-remove'), 0);
            });
          });
        }
      }
      renderMobileList(t);

      const canAdd = t.qty > 0 && (minCheckout <= 0 || t.qty >= minCheckout);
      if (addBtn) addBtn.disabled = !canAdd;
      mobileAddBtns.forEach(function (btn) {
        btn.disabled = !canAdd;
      });
      syncCheckoutButtons();
    }

    async function loadEditFromCart() {
      if (!editBundleId) return;

      const rootUrl = window.Shopify?.routes?.root || '/';
      try {
        const res = await fetch(rootUrl + 'cart.js');
        const cart = await res.json();
        const line = (cart.items || []).find(function (item) {
          return item.properties && item.properties._coiner_bundle_id === editBundleId;
        });

        if (!line) {
          editBundleId = '';
          bundleIdForCart = uuid();
          return;
        }

        editLineKey = line.key;
        bundleIdForCart = editBundleId;
        if (editBanner) editBanner.classList.remove('is-hidden');

        let items = [];
        try {
          items = JSON.parse(line.properties._coiner_items || '[]');
        } catch (e) {
          items = [];
        }

        selections.clear();
        root.querySelectorAll('.coiner-bundle-card').forEach(function (card) {
          card.classList.remove('is-active');
          const display = card.querySelector('[data-qty-display]');
          if (display) display.textContent = '0';
        });

        items.forEach(function (item) {
          if (item && item.id && item.qty) setQty(String(item.id), item.qty);
        });

        syncCheckoutButtons();
      } catch (e) {
        console.warn('Coiner bundle: could not load cart for edit', e);
      }
    }

    async function addToCart() {
      const t = totals();
      if (t.qty === 0) return;
      if (!anchorVariantId) {
        alert('Bundle variant is not configured.');
        return;
      }

      const properties = buildProperties(t);
      const buttons = [addBtn].concat(Array.from(mobileAddBtns)).filter(Boolean);
      const loadingText = editLineKey ? 'Updating…' : 'Adding…';

      buttons.forEach(function (b) {
        b.disabled = true;
        b.dataset.loading = '1';
        b.dataset.label = checkoutLabel();
        b.textContent = loadingText;
      });

      try {
        const rootUrl = window.Shopify?.routes?.root || '/';
        let res;

        if (editLineKey) {
          res = await fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: editLineKey,
              quantity: 1,
              properties: properties,
            }),
          });
        } else {
          res = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: anchorVariantId,
                  quantity: 1,
                  properties: properties,
                },
              ],
            }),
          });
        }

        const data = await res.json();
        if (data.status && data.status >= 400) {
          throw new Error(data.description || data.message || 'Could not update cart');
        }

        window.location.href = rootUrl + 'cart';
      } catch (err) {
        alert(err.message || 'Something went wrong updating your bundle.');
        buttons.forEach(function (b) {
          delete b.dataset.loading;
          if (b.dataset.label) b.textContent = b.dataset.label;
        });
        updateUI();
      }
    }

    root.querySelectorAll('[data-coiner-start]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = btn.closest('.coiner-bundle-card')?.dataset.variantId;
        if (id) setQty(id, 1);
      });
    });

    root.querySelectorAll('[data-coiner-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = btn.closest('.coiner-bundle-card')?.dataset.variantId;
        if (id) changeQty(id, 1);
      });
    });

    root.querySelectorAll('[data-coiner-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = btn.closest('.coiner-bundle-card')?.dataset.variantId;
        if (id) changeQty(id, -1);
      });
    });

    const searchInput = root.querySelector('[data-coiner-search]');
    const grid = root.querySelector('[data-coiner-variant-grid]');
    if (searchInput && grid) {
      searchInput.addEventListener('input', function () {
        const q = searchInput.value.trim().toLowerCase();
        grid.querySelectorAll('.coiner-bundle-card').forEach(function (card) {
          const title = (card.dataset.title || '').toLowerCase();
          card.style.display = !q || title.includes(q) ? '' : 'none';
        });
      });
    }

    mobileToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        setMobileSheetOpen(!mobileRoot?.classList.contains('is-expanded'));
      });
    });

    mobileBackdrop?.addEventListener('click', function () {
      setMobileSheetOpen(false);
    });

    mobileClose?.addEventListener('click', function () {
      setMobileSheetOpen(false);
    });

    mobileHide?.addEventListener('click', function () {
      setMobileSheetOpen(false);
    });

    mobileAddBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        addToCart();
      });
    });

    addBtn?.addEventListener('click', addToCart);

    updateLadderPrices(basePrice);
    loadEditFromCart().then(function () {
      updateUI();
    });
    updateUI();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-coiner-bundle-page]').forEach(initSection);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll?.('[data-coiner-bundle-page]').forEach(initSection);
  });
})();
